<pp-select
  [class]="ppClass"
  [ppItems]="items"
  [ppWidth]="ppWidth"
  [ppSelectedItem]="{
    value: ppOption,
    label: '',
    customFields: selectedOption?.customFields,
    tooltip: selectedOption?.tooltip,
  }"
  (ppSelectItem)="changeFieldCondition($event)"
  [ppNoSearchBar]="ppNoSearchBar()"
  require
>
  <ng-container selected>
    @if (!selectedOption) {
      <span class="placeholder-text" data-test="advancedFilterSelectOptionLabel">{{
        'select_option' | ppTranslate
      }}</span>
    } @else {
      <span class="advancedFilterOption__select-content">
        @if (selectedOption.iconSrc) {
          <pp-icon
            data-test="advancedFilterOptionIcon"
            [ppSrc]="selectedOption.iconSrc"
            ppClass="setSize14"
            ppTooltip
            [ppTitle]="selectedOption.tooltip"
            [ppSanitize]="false"
          />
        }
        <span
          data-test="advancedFilterOptionLabel"
          ppTooltip
          aria-label="advanced filter option label"
          [ppTitle]="selectedOption.label"
          class="advancedFilterOption__select-content--text"
          >{{ selectedOption.label }}</span
        >
      </span>
    }
  </ng-container>
</pp-select>
